import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";
import "./index.css";
export class NavBarTabsItem extends PureComponent {
  render() {
    const { className, children, active, ...others } = this.props;
    const cls = classNames({
      "navbar__item": true,
      "bartem_on": active
    }, className);
    return (
      <div className={ cls } { ...others }>
        { children }
      </div>
    );
  }
}
